/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_Reference_DateInputs */

const en_cases_col_reference_date = /** @type {(inputs: Cases_Col_Reference_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incident / due date`)
};

const pt_br2_cases_col_reference_date = /** @type {(inputs: Cases_Col_Reference_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinistro / vencimento`)
};

/**
* | output |
* | --- |
* | "Incident / due date" |
*
* @param {Cases_Col_Reference_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_reference_date = /** @type {((inputs?: Cases_Col_Reference_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_Reference_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_reference_date(inputs)
	return pt_br2_cases_col_reference_date(inputs)
});